import "jquery";
import "pickadate/lib/picker";
import "pickadate/lib/picker.date";
import "pickadate/lib/picker.time";
import "pickadate/lib/translations/nl_NL";
import "nouislider";
import "nouislider/distribute/nouislider.css";

/**
 * @private
 */
let datepickersInitialized = false;

Date.prototype.toInputDateValue = function () {
  var local = new Date(this);
  local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
  return local.toJSON().slice(0, 10);
};

Date.prototype.addDays = function (noOfDays) {
  this.setTime(this.getTime() + noOfDays * 86400000);
  return this;
};

/**
 * A friendly wrapper for HTML5 or pickadate date pickers.
 */
export class GVDatepicker {
  /**
   * Creates a GVDatepicker object
   * @param element The jquery element to use. Should be an input type=date.
   * @param {Date} value The date value to initialize the picker to, defaults to today.
   * @param {Date} minDate The earliest date allowed for the picker, defaults to today.
   * @param {Date} maxDate The latest date allowed for the picker, defaults to one year from now.
   */
  constructor(
    element,
    value = null,
    minDate = new Date(),
    maxDate = new Date().addDays(365)
  ) {
    const that = this;

    if (!datepickersInitialized) {
      GVDatepicker.initDatePickers();
    }

    let defaultValue = null;

    if (element.val() !== "") {
      defaultValue = new Date(element.val());
    }

    value = value || defaultValue || minDate;

    console.dir(value);

    /**
     * The current minimum date set on the element
     * @type {Date}
     * @private
     */
    this._minimum = minDate;

    /**
     * The current maximum date set on the element
     * @type {Date}
     * @private
     */
    this._maximum = maxDate;

    this.format = "d-mm-yyyy";

    if (!GVDatepicker.useHtml5DatePickers()) {
      // Prevent Edge from also displaying its own datepicker
      element.attr("type", "");

      element.pickadate({
        min: minDate,
        max: maxDate,
        value: value,
        format: this.format,
        today: "",
        clear: "",
        close: "",
        klass: { highlighted: "picker__day" },
      });

      element.pickadate("picker").on({
        set: function () {
          element.val(element.pickadate("picker").get("select", that.format));
          that.onChange();
        },
      });
    } else {
      element.attr("min", minDate.toInputDateValue());
      element.attr("max", maxDate.toInputDateValue());
      element.val(value.toInputDateValue());
      element.change(() => that.onChange());
    }

    this.element = element;
    this.value = value;
  }

  onChange() {}

  /**
   * Sets the value of the date picker.
   * @param {Date} value
   */
  set value(value) {
    if (!GVDatepicker.useHtml5DatePickers()) {
      this.element.pickadate("picker").set("select", value);
    } else {
      this.element.val(value.toInputDateValue());
    }
  }

  get value() {
    if (GVDatepicker.useHtml5DatePickers()) {
      return new Date(this.element.val());
    } else {
      return this.element.pickadate("get", "select").obj;
    }
  }

  // noinspection JSUnusedGlobalSymbols
  set minimum(value) {
    if (this._minimum === value) {
      return;
    }
    this._minimum = value;
    if (!GVDatepicker.useHtml5DatePickers()) {
      this.element.pickadate("picker").set("min", value);
    } else {
      this.element.attr("min", value.toInputDateValue());
    }
  }

  get minimum() {
    return this._minimum;
  }

  set maximum(value) {
    if (this._maximum === value) {
      return;
    }
    this._maximum = value;
    if (!GVDatepicker.useHtml5DatePickers()) {
      this.element.pickadate("picker").set("max", value);
    } else {
      this.element.attr("max", value.toInputDateValue());
    }
  }

  get maximum() {
    return this._maximum;
  }

  /**
   * Check whether we should use HTML5 datepickers or fallback.
   *
   * @returns {boolean}
   * @private
   */
  static useHtml5DatePickers() {
    return (
      1 /*Modernizr.inputtypes.date*/ &&
      window.navigator.userAgent.indexOf("Edge/") <= 0 &&
      window.navigator.userAgent.indexOf("iPhone") <= 0 &&
      window.navigator.userAgent.indexOf("iPad") <= 0 &&
      window.navigator.userAgent.indexOf("iPod") <= 0
    );
  }

  /**
   * Check whether we should use mobile friendly form elements
   *
   * @returns {boolean}
   * @private
   */
  static useMobileDatePickers() {
    return (
      window.navigator.userAgent.indexOf("iPhone") >= 0 ||
      window.navigator.userAgent.indexOf("iPod") >= 0 ||
      !window.matchMedia("(min-width: 576px)").matches
    );
  }

  /**
   * @private
   */
  static initDatePickers() {
    let stylename = null;

    if (GVDatepicker.useMobileDatePickers()) stylename = "default";
    else stylename = "classic";

    const head = $("head");
    const linkbase = `/assets/components/pickadate/lib/themes/${stylename}`;

    head.append(
      `<link rel="stylesheet" type="text/css" href="${linkbase}.css">`
    );
    head.append(
      `<link rel="stylesheet" type="text/css" href="${linkbase}.date.css">`
    );
    head.append(
      `<link rel="stylesheet" type="text/css" href="${linkbase}.time.css">`
    );

    datepickersInitialized = true;
  }

  devalidate() {
    this.element.removeClass("is-valid is-invalid");
  }

  set valid(val) {
    this.devalidate();
    this.element.addClass(val ? "is-valid" : "is-invalid");
  }
}

/**
 * This class implements a text field with autocomplete
 */
export class GVAutocomplete {
  /**
   * Creates an autocomplete object
   * @param {jQuery} element The jQuery element to attach to
   * @param {string} url The base URL of the autocomplete API.
   * @param {number} maxSuggestions The number of suggestions to show at most.
   * @param {string} defaultValue The initial value to fill into the field, will be removed on first focus.
   */
  constructor(element, url = "/autocomplete/", maxSuggestions, defaultValue) {
    /**
     * The base URL of the autocomplete API
     * @type {string}
     */
    this.baseURL = url;

    /**
     * The number of suggestions to show at tmost
     * @type {number}
     */
    this.maxSuggestions = maxSuggestions || element.attr("data-max-sugg") || 5;

    /**
     * The input element this autocomplete uses
     * @type {jQuery}
     */
    this.element = element;

    /**
     * The currently outstanding data request
     * @type {jqXHR | null}
     */
    this.currentRequest = null;

    /* Wrap the input box with a div so we can show our suggestions right below it*/
    this.element.wrap("<div class='gv_ac_wrap'></div>");

    /**
     * The wrapper div around the input box.
     * @type {jQuery}
     */
    this.container = this.element.parent();

    /**
     * The template function for the list
     * @type {function}
     */
    this.listTemplate = require("./views/autocomplete.handlebars");

    /**
     * The index of the currently selected item, or -1 if none is selected.
     * @type {number}
     */
    this.selected = -1;

    /* Set the default value */
    this.element.val(defaultValue || element.attr("data-def-value") || "");
    /**
     * Whether the element is currently set to the default value
     * @type {boolean}
     */
    this.hasDefaultValue = true;

    /* Register the event handlers */
    this.element.on("input", (e) => this.onInput(e));
    this.element.on("keydown", (e) => this.onKeyDown(e));
    this.element.on("focus", (e) => this.onFocus(e));
    $(document).on("click", (e) => this.onDocumentClick(e));
  }

  /**
   * Requests a new set of suggestions from the server
   * @param request The string to complete
   * @private
   */
  fetchSuggestions(request) {
    const suggURL = this.baseURL + encodeURIComponent(request);

    if (this.currentRequest != null) this.currentRequest.abort();

    this.currentRequest = $.ajax(suggURL, {
      success: (d) => this.onFetchComplete(d),
      error: () => this.onFetchError(),
      dataType: "json",
    });
  }

  /**
   * Gets called if the server failed to provide suggestions
   * @private
   */
  onFetchError() {
    this.currentRequest = null;
  }

  /**
   * Gets called when the server has returned the suggestions we've asked for
   * @param {array} d The data returned by the server, as an array of {value:, code:} objects.
   * @private
   */
  onFetchComplete(d) {
    if (d.length !== 0) this.showSuggestions(d);
  }

  /**
   * Handles removing the default value on first focus.
   * @param {Event} e The event information
   * @private
   */
  onFocus(e) {
    this.element.select();
    /*if ( this.hasDefaultValue ){
            this.hasDefaultValue = false;
            this.element.select();
            //this.element.val("");
        }*/
  }

  /**
   * The text input event handler, requests new suggestions and closes old suggestions.
   * @param {Event} e The event information
   * @private
   */
  onInput(e) {
    const val = this.element.val();
    this.typedValue = val;

    this.closeSuggestions();

    if (val) this.fetchSuggestions(val);
  }

  /**
   * The key press event handler, provides keyboard interaction.
   * @param {Event} e The event information
   * @private
   */
  onKeyDown(e) {
    if (e.keyCode === 40) {
      /* The (down) key was pressed */

      this.selected++;
      if (this.selected >= this.numSuggestions) {
        this.selected = this.numSuggestions - 1;
      }
      this.selectSuggestion(this.selected);
    } else if (e.keyCode === 38) {
      /* The (up) key was pressed */

      this.selected--;
      if (this.selected < 0) {
        this.selected = -1;
      }
      this.selectSuggestion(this.selected);
    } else if (e.keyCode === 13) {
      /* The (return) key was pressed */

      e.preventDefault();
      if (this.selected >= 0) {
        this.suggestionList.find("li").eq(this.selected).click();
      }
    } else if (e.keyCode === 27) {
      /* The (escape) key was pressed */

      this.closeSuggestions();
    }
  }

  /**
   * Event handler for clicks outside the suggestion list, closes the suggestions.
   * @param e {Event} The event information
   * @private
   */
  onDocumentClick(e) {
    this.closeSuggestions();
  }

  /**
   * Event handler for mouse-, and keyboard handled selection of suggestions.
   * Enters the value of the suggestion into the text field.
   * @param e {Event} The event information
   * @private
   */
  onSuggestionClick(e) {
    const target = $(e.target);

    if (!target.is("li")) {
      return;
    }

    this.closeSuggestions();
    this.element.val(target.html());
  }

  /**
   * Opens the list of suggestions, but does not populate it.
   * @private
   */
  openSuggestions() {
    this.container.append("<div class='gv_ac_obox'></div>");
    this.suggestionList = this.container.find(".gv_ac_obox");
    this.selected = -1;
  }

  /**
   * Closes the list of suggestions.
   */
  closeSuggestions() {
    if (!this.suggestionList) {
      return;
    }
    this.suggestionList.remove();
    this.suggestionList = null;
    this.element.val(this.typedValue);
  }

  /**
   * Populates and (if necessary) opens the suggestion list
   * @param {array} data The suggestions, as an array of {value:, code:} objects.
   * @private
   */
  showSuggestions(data) {
    data = data.slice(0, this.maxSuggestions);

    const html = this.listTemplate({ suggestions: data });

    if (!this.suggestionList) {
      this.openSuggestions();
    }

    this.numSuggestions = data.length;

    this.suggestionList.html(html);

    this.suggestionList
      .find("li")
      .on("click", (e) => this.onSuggestionClick(e));
  }

  /**
   * Undoes all highlighting of selected items
   * @private
   */
  deselectSuggestions() {
    this.suggestionList.find(".gv_ac_active").removeClass("gv_ac_active");
  }

  /**
   * Highlights an item to indicates its selection.
   * @param i The index of the item to highlight, or -1 for none.
   * @private
   */
  selectSuggestion(i) {
    this.deselectSuggestions();
    if (i >= 0) {
      let el = this.suggestionList.find("li").eq(i);
      el.addClass("gv_ac_active");
      this.element.val(el.html());
    }
  }

  /**
   * Sets the value of the text field.
   * @param {string} value
   */
  set value(value) {
    this.element.val(value);
    this.typedValue = value;
    this.closeSuggestions();
  }

  /**
   * Gets the value of the text field
   * @returns {string}
   */
  get value() {
    return this.element.val();
  }

  devalidate() {
    this.element.removeClass("is-valid is-invalid");
  }

  set valid(val) {
    this.devalidate();
    this.element.addClass(val ? "is-valid" : "is-invalid");
  }
}

/**
 * This class implements a slider for selecting a range of values
 */
export class GVRangeSlider {
  /**
   * Creates a range slider object
   * @param {jQuery} element The jQuery element to attach to
   */
  constructor(element) {
    function pad(num, size) {
      var s = "000000000" + num;
      return s.substr(s.length - size);
    }

    this.formatters = {
      time_hm: function (v) {
        const hrs = Math.floor(v / 60);
        const mis = v % 60;
        return hrs + ":" + pad(mis, 2);
      },
      default: function (v) {
        return v.toString();
      },
    };

    /*
     * The div element to attach the slider to
     * @type {jQuery}
     */
    this.element = element;

    this.valueLabels = [];
    this.onChange = function () {};
    const leftSpanID = this.element.attr("id") + "_left_val";
    const rightSpanID = this.element.attr("id") + "_right_val";

    this.element.after(`<span id="${leftSpanID}"></span>`);
    this.element.after(`<span id="${rightSpanID}"></span>`);

    this.valueLabels[0] = $(`#${leftSpanID}`);
    this.valueLabels[1] = $(`#${rightSpanID}`);
    this.valueLabels[1].addClass("float-right");

    this.minValue = +element.attr("data-min") || 0;
    this.maxValue = +element.attr("data-max") || 100;
    this.step = +element.attr("data-step") || 1;
    var startLeft = this.minValue;
    var startRight = this.maxValue;
    const formatter = element.attr("data-fmt") || "default";
    this.formatter = this.formatters[formatter];

    this.slider = noUiSlider.create(this.element.get()[0], {
      range: {
        min: this.minValue,
        max: this.maxValue,
      },
      connect: true,
      step: this.step,
      start: [startLeft, startRight],
    });

    var that = this;

    this.slider.on("update", function (vals, hnd) {
      that.valueLabels[hnd].html(that.formatter(+vals[hnd]));
    });

    this.slider.on("change", function (vals, hnd) {
      that.valueLabels[hnd].html(that.formatter(+vals[hnd]));
      that.onChange();
    });
  }

  get valueLeft() {
    return +this.slider.get()[0];
  }

  get valueRight() {
    return +this.slider.get()[1];
  }
}

/**
 * This class implements a slider for a single value
 */
export class GVValueSlider {
  /**
   * Creates a range slider object
   * @param {jQuery} element The jQuery element to attach to
   */
  constructor(element) {
    function pad(num, size) {
      var s = "000000000" + num;
      return s.substr(s.length - size);
    }

    this.formatters = {
      time_hm: function (v) {
        const hrs = Math.floor(v / 60);
        const mis = v % 60;
        return hrs + ":" + pad(mis, 2);
      },
      default: function (v) {
        return v.toString();
      },
    };

    /*
     * The div element to attach the slider to
     * @type {jQuery}
     */
    this.element = element;
    this.onChange = function () {};

    const spanID = this.element.attr("id") + "_val";

    this.element.after(`<span id="${spanID}"></span>`);
    this.valueLabel = $(`#${spanID}`);

    this._minValue = +element.attr("data-min") || 0;
    this._maxValue = +element.attr("data-max") || 100;
    this.step = +element.attr("data-step") || 1;

    var start = 50;
    const formatter = element.attr("data-fmt") || "default";
    this.formatter = this.formatters[formatter];

    this.slider = noUiSlider.create(this.element.get()[0], {
      range: {
        min: this._minValue,
        max: this._maxValue,
      },
      connect: true,
      step: this.step,
      start: start,
    });

    var that = this;
    this.lastVal = -1;

    this.slider.on("change", function (val) {
      if (val === +that.lastVal) return;
      that.lastVal = +val;
      that.valueLabel.html(that.formatter(+val));
      that.onChange();
    });

    this.slider.on("update", function (val) {
      that.valueLabel.html(that.formatter(+val));
    });

    this.slider.on("start", function () {
      that.changing = true;
    });

    this.slider.on("end", function () {
      that.changing = false;
    });
  }

  set minValue(mV) {
    this._minValue = mV;
    this.slider.updateOptions(
      {
        range: {
          min: this._minValue,
          max: this._maxValue,
        },
      },
      false
    );
  }

  set maxValue(mV) {
    this._maxValue = mV;
    this.slider.updateOptions(
      {
        range: {
          min: this._minValue,
          max: this._maxValue,
        },
      },
      false
    );
  }

  set value(v) {
    if (this.changing) return;
    this.slider.set(+v);
    this.lastVal = +v;
  }

  get value() {
    return +this.slider.get();
  }
}
